import { createSelector } from 'reselect';

const selectCommunities = (state: any) => state.communities;


export const selectCommunitiesCurrentItem = createSelector([selectCommunities], (communities) => communities.current);

export const selectCommunitiesListItems = createSelector([selectCommunities], (communities) => communities.list);

export const selectCommunitiesItemById = (itemId: any) =>
    createSelector(selectCommunitiesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCommunitiesQueryItems = createSelector([selectCommunities], (communities) => communities.query);

export const selectCommunitiesCreatedItem = createSelector([selectCommunities], (communities) => communities.create);
export const selectCommunitiesPublishedItem = createSelector([selectCommunities], (communities) => communities.publish);

export const selectCommunitiesUpdatedItem = createSelector([selectCommunities], (communities) => communities.update);

export const selectCommunitiesReadItem = createSelector([selectCommunities], (communities) => communities.read);

export const selectCommunitiesDeletedItem = createSelector([selectCommunities], (communities) => communities.delete);

export const selectCommunitiesSearchedItems = createSelector([selectCommunities], (communities) => communities.search);

export const selectCommunitiesItemsCount = createSelector([selectCommunities], (communities) => communities.count);

export const selectCommunitiesItemsFilter = createSelector([selectCommunities], (communities) => communities.filter);